import React, { useEffect, useMemo, useRef, useState } from "react";
import { ProductCard } from "./ProductCard";
import { FilterSection } from "./FilterSection";
import {
  IconButton,
  useMediaQuery,
  useTheme,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Pagination,
} from "@mui/material";

import { FilterAlt } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { fetchAllProduct, getProductsByCategoryId } from "../../../State/customer/ProductSlice";
import { useLocation, useParams } from "react-router-dom";
import { getCategoryLevelsFromId } from "../../data/Filter/categoryFilter";

export const Product = () => {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
 const dispatch = useAppDispatch();
  const { categoryId } = useParams();
  const { search } = useLocation();           // ✅ primitive string; changes only when URL query changes

  const [sort, setSort] = useState<string>("");
  const [page, setPage] = useState(1);

  const product = useAppSelector(s => s.product);
 

  // Parse the query **from the search string**, not useSearchParams object
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const minStr = query.get("price")?.split("-")[0] ?? "";
  const maxStr = query.get("price")?.split("-")[1] ?? "";
  const color  = query.get("color") || undefined;
  
  const levels = categoryId ? getCategoryLevelsFromId(categoryId) : undefined;
  
  const categoryName =
  levels?.level3?.name ??
  levels?.level1?.name ??
  "Not Found";


  const isLevel1 = levels?.level1?.categoryId === categoryId && !levels?.level2;
  const minDiscount = query.get("minDiscount")
    ? Number(query.get("minDiscount"))
    : undefined;

    useEffect(() => {
      setPage(1);
    }, [categoryId, color, minStr, maxStr, minDiscount, sort]);
    
    
  // Build a stable request only from primitives
  const request = useMemo(() => {
    if (!categoryId) return null; // gate if category is required

    return {
      categoryId,
      color,
      minPrice: minStr ? Number(minStr) : undefined,
      maxPrice: maxStr ? Number(maxStr) : undefined,
      minDiscount,
      sort,
      pageNumber: page - 1,
    };
  }, [categoryId, color, minStr, maxStr, minDiscount, sort, page]);

  // Prevent duplicate dispatches (React 18 dev & identical inputs)
  const lastKey = useRef<string>("");


useEffect(() => {
  if (!request) return;

  const key = JSON.stringify({ request, isLevel1 });
  if (lastKey.current === key) return;
  lastKey.current = key;

  if (isLevel1) {
    // xem tất cả product thuộc cây Home & Furniture
    dispatch(getProductsByCategoryId({
      categoryId: request.categoryId,
      pageNumber: request.pageNumber,
    }));
    console.log("i am here for ByCategoryId");
  } else {
    console.log("i am here for fetchAllProduct");
    // xem product theo category cụ thể + filter
    dispatch(fetchAllProduct(request));
  }
}, [request, isLevel1, dispatch]);
  console.log("product.totalPages: ",product.totalPages);
  return product.products.length>0||product.categoryProducts.length>0? (
    <div className="-z-10 mt-10 ">
      <div className="">
        <h1 className="text-3xl text-center text-gray-700 pb-5 px-9 uppercase font-bold space-x-2">
          {(product.products.length > 0 && product.products[0])||(product.categoryProducts.length>0&&product.categoryProducts[0])
            ? categoryName
            : "No Category Found"}
        </h1>
      </div>

      <div className="lg:flex  ">
        <section className="filter_section hidden lg:block w-[20%]">
          {isLarge && <FilterSection />}
        </section>

        <div className="w-full lg:w-[80%] lg:mx-auto  space-y-5 2xl:px-[3vw]">
          <div className="flex justify-between items-center px-9 h-[40px]">
            <div className="relative w-[50%]">
              {!isLarge && (
                <IconButton>
                  <FilterAlt />
                </IconButton>
              )}
              {isLarge && <Box>{/* <FilterSection /> */}</Box>}
            </div>
            <FormControl size="small" sx={{ width: "200px" }}>
              <InputLabel id="demo-simple-select-label">Sort</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={sort}
                label="Sort"
                onChange={(e) => setSort(e.target.value as "price_low" | "price_high" | "")}
              >
                <MenuItem value={"price_low"}>Price: Low - High</MenuItem>
                <MenuItem value={"price_high"}>Price: High - Low</MenuItem>
              </Select>
            </FormControl>
          </div>
          <Divider
            orientation="horizontal"
            flexItem
            className="hidden lg:block"
          />
          <section className="products_section grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-6 gap-5 lg:gap-x-7 gap-y-16 justify-center">
            {isLevel1?(product.categoryProducts.map((item, index) => (
              <ProductCard item={item} key={index} />
            ))):(product.products.map((item, index) => (
              <ProductCard item={item} key={index} />
            )))}
            
          </section>
          <div className="flex justify-center py-16 ">
            <Pagination
              page={page}
              onChange={(_, value) => setPage(value)}
              count={isLevel1?product.categoryTotalPages:product.totalPages||1}
              color="primary"
              shape="rounded"
            />
          </div>
        </div>
      </div>
    </div>
  ):(<div className="flex justify-center items-center h-[80vh]"><h1 className=" text-3xl text-center text-gray-700 pb-5 px-9 uppercase font-bold space-x-2">Does not found any product match the category search</h1></div>);
};
